const PGAdapter = require('./pg-adapter')

/**
 * Generic PGAdapter for raw external data tables.
 * Defaults to raw.external_stock_data but accepts a tableName to be reused for other raw tables.
 */
const columnPreparers = {
  created_at: (key, value) => {
    return [{
      statement: `"${key}">=%INDEX%::date`,
      value
    }]
  }
}
class RawExternalDataPGAdapter extends PGAdapter {
  constructor ({ pgConnection, username, logger, tableName = 'raw.external_stock_data' }) {
    const columns = [
      'id',
      'organisation_id',
      'data',
      'created_at',
      'updated_at'
    ]

    super(
      pgConnection,
      tableName,
      username,
      columns,
      'id',
      columnPreparers,
      logger
    )
  }

  /**
   * Get all raw records for an organization
   * @param {String} organisationId - Organization ID
   * @param {String} date - Optional date filter
   * @param {Object} options - Optional parameters
   * @returns {Promise<Array>} - Array of raw records
   */
  async getByOrganisation (organisationId, date = null, options = {}) {
    const filter = { organisation_id: organisationId }
    if (date) {
      filter.created_at = date
    }
    const listOptions = {
      filter,
      ordering: '-created_at',
      client: options.client
    }
    const { results } = await this.getList({
      ...listOptions,
      limit: Number.MAX_SAFE_INTEGER
    })

    return results
  }
}

module.exports = RawExternalDataPGAdapter
